class Validator {
  constructor(rules = []) {
    this.rules = rules;
  }

  validate() {
    let valid = true;

    this.rules.forEach(rule => {
      if (typeof this[`_${rule.type}`] !== 'undefined') {
        let singleValid = this[`_${rule.type}`](rule);
        if (!singleValid) {
          valid = false;
        }
      }
    });

    if (!valid) {
      throw new Error(`Failed loading component.`);
    }

    return valid;
  }

  _notNull(rule) {
    let valid = false;

    if (rule.selector !== null) {
      valid = true;
    }

    return valid;
  }

  _elementExists(rule) {
    let valid = false;

    if (document.querySelectorAll(rule.selector).length > 0) {
      valid = true;
    }

    return valid;
  }
}

module.exports = Validator;



// WEBPACK FOOTER //
// ./src/rcs_cor_continous-related-link/Validator.js